module.exports = __webpack_public_path__ + "static/media/12.3d9b4417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/12.jpg
// module id = 471
// module chunks = 0